var mySlider = require("./../vertical-bootstrap-slider");
let verticalSlider;
(function($) {
  let content_height = 580; // the height of the content, discluding the header/footer
  let number_of_column = 1; // the height of the content, discluding the header/footer
  var page = 1; // the beginning page number to show in the footer
  var last = 0;
  var toc_last = 0;
  // console.log(view_type);
  $.fn.scrapbookFullPreview = {
    init: function() {
      $(function() {
        $('[data-toggle="tooltip"]').tooltip();
      });
      $(".page-scrapbook-preview .scrapbook_meta li.scrapbook-popover").hover(
        function() {
          $(this).popover("show");
        },
        function() {
          $(this).popover("hide");
        }
      );
      $(".page-scrapbook-preview .scrapbook_meta>li.scrapbook-tooltip").hover(
        function() {
          $(this).tooltip("show");
        },
        function() {
          $(this).tooltip("hide");
        }
      );

      //Get the screen size
      var screenWidth = getWidth();

      //Set the columnizer variables
      adaptative_columns(screenWidth);

      // console.log('content_height = '+content_height);
      // console.log('number_of_column = '+number_of_column);
      $.fn.buildNewsletter();
    }
  };

  // open in fullscreen
  $(".page-node .requestfullscreen").click(function() {
    $(".page-node").fullscreen({ overflow: "auto" });
    $("body").addClass("fullscreen");
    $(".slider-content-section")
      .addClass("fixed-slider")
      .removeAttr("style");
    var fullscreen_mode_ele = document.querySelector(".fullscreen .page-node");
    if (fullscreen_mode_ele) {
      fullscreen_mode_ele.onscroll = logScroll;
      calculateSliderHeight();
    }
    return false;
  });

  $("#expand-container .video-img").on("click", function(e) {
    e.preventDefault();
    var src = $(this).attr("href");
    var content = $(this).data("content");

    if (src) {
      $("#videoModal .video-iframe").attr("src", src);
    } else {
      $("#videoModal .video-iframe").remove();
      $("#videoModal .modal-body").append(content);
      $("#videoModal .modal-body iframe").addClass("video-iframe");
      $("#videoModal .modal-body iframe").removeAttr("width");
      $("#videoModal .modal-body iframe").removeAttr("height");
    }

    $("#videoModal").modal("show");
  });
  $("#videoModal").on("hidden.bs.modal", function() {
    $("#videoModal .video-iframe").attr("src", "");
  });

  // exit fullscreen
  $(".page-node .exitfullscreen").click(function() {
    $("body").removeClass("fullscreen");
    $(".slider-content-section").removeClass("fixed-slider");
    $.fullscreen.exit();
    calculateSliderHeight();
    return false;
  });

  // document's event
  $(document).bind("fscreenchange", function(e, state, elem) {
    // if we currently in fullscreen mode
    if ($.fullscreen.isFullScreen()) {
      $(".page-node .requestfullscreen").hide();
      $(".page-node .exitfullscreen").show();
      // $('#obos .fade.in').css({ "z-index": "11111111111111111111111111", "position": "relative" });
    } else {
      $(".page-node .requestfullscreen").show();
      $(".page-node .exitfullscreen").hide();
    }
  });

  $.fn.buildNewsletter = function() {
    if ($("#waitclipnumber").html() == "") {
      $("#waitclipnumber").html(1);
    } else {
      $("#waitclipnumber").html(parseInt($("#waitclipnumber").html()) + 1);
    }

    if ($("#mainPrint").contents().length > 0) {
      // console.log("start scrapbook clip");

      // when we need to add a new page, use a jq object for a template
      // or use a long HTML string, whatever your preference
      $page = $("#page_template")
        .clone()
        .removeAttr("id")
        .addClass("page")
        .css("display", "block");
      // fun stuff, like adding page numbers to the footer
      //$page.find(".footer span").append(page);
      $(".wrapper").append($page);
      page++;

      // here is the columnizer magic
      $("#mainPrint").columnize({
        columns: number_of_column,
        target: ".page:last .content",
        buildOnce: true,
        overflow: {
          height: content_height,
          id: "#mainPrint",
          doneFunc: function() {
            $.fn.buildNewsletter();
            last++;
            var pageAdded = parseInt($(".page").length);
            if ($(".page-layout").length != 0) {
              $(".page").remove();
            }
            // console.log('last=' + last);
            // console.log('pageAdded=' + pageAdded);
            if (last === pageAdded) {
              // $('.page').find('.column').css('min-height', '610px');
              // $('.page').last().remove();
              $("#mainPrint").remove();

              // console.log('last=' + last);
              // console.log('pageAdded=' + pageAdded);

              var homepage_html = $(".homepage").html();
              $(".homepage").remove();
              $(".scrapbook-half-preview-list-wrap .wrapper").prepend(
                '<div class="page homepage-layout"><div class="homepage">' + homepage_html + "</div></div>"
              );
              $("img.lazy").lazyload();
              buildTocData(); //Set the section name and the clip name into table of conten section
              if (number_of_column > 1) {
                $.fn.builToc(); //build the Table Of Content section
              } else {
                // $.fn.builToc(); //build the Table Of Content section

                $.fn.givePageNumber();
                $.fn.applySlider();
                $.fn.pageNoTotitle();
              }
              $("#toc-content").hide();
            }
          }
        }
      });
      $(".wait").hide();
    }
  };

  //html section toc
  function buildTocData() {
    var section_html_toc = [];
    $(".page:not(.homepage-layout)").each(function(index) {
      $(this)
        .find(".column")
        .each(function() {
          var sec_id = parseInt(
            $(this)
              .find(".section-title")
              .data("scidx")
          );
          var page_no = index + 2;
          if (sec_id != 0 && !section_html_toc[sec_id]) {
            section_html_toc[sec_id] = sec_id;
            if ($(this).find(".section-title").length > 0) {
              var sec_page_no = '<span class="page-number">' + page_no + "</span>";
              $("#toc-content").append(
                '<div class="toc-section"><a href="#" class="toc-section-title">' +
                  $(this)
                    .find(".section-title")
                    .text()
                    .trim() +
                  sec_page_no +
                  "</a></div>"
              );
            }
          }
          if ($(this).find(".title").length > 0) {
            var author_source =
              '<div class="toc-clip-sub-title">' +
              $(this)
                .find(".author")
                .text()
                .trim() +
              " | ";

            if (!isNaN(page_no)) {
              author_source +=
                $(this)
                  .find(".source")
                  .text()
                  .trim() +
                '</div><div class="page-number-style">' +
                page_no +
                "</div>";

              $("#toc-content").append(
                '<div><a href="#" class="toc-clip-title"><span class="page-number">' +
                  page_no +
                  "</span>" +
                  $(this)
                    .find(".title")
                    .text()
                    .trim() +
                  author_source +
                  "</a></div>"
              );
            }
          }
        });
    });
    // $("#toc-content").height($("#toc-content").height());
  }

  $.fn.builToc = function() {
    if ($("#toc-content").contents().length > 0) {
      // when we need to add a new page, use a jq object for a template
      // or use a long HTML string, whatever your preference
      $tocPage = $("#toc_page_template")
        .clone()
        .removeAttr("id")
        .addClass("page-toc")
        .css("display", "block");
      // fun stuff, like adding page numbers to the footer
      //$tocPage.find(".footer span").append(page);

      // $(".wrapper .homepage-layout").after($tocPage);
      $(".wrapper").append($tocPage);
      page++;
      // here is the columnizer magic
      $("#toc-content").columnize({
        columns: number_of_column,
        target: ".page-toc:last .content",
        buildOnce: true,
        overflow: {
          height: content_height,
          id: "#toc-content",
          doneFunc: function() {
            $.fn.builToc();
            toc_last++;

            //Check the last page of TOC have any link or not, if not then remove the last page
            var last_toc_page = parseInt($(".page-toc:last .first .page-number-style:first").text());
            if (isNaN(last_toc_page)) {
              $(".page-toc:last").remove();
            }

            var pageAdded = parseInt($(".page-toc").length);
            if ($("#toc-content").length != 0) {
              $("#toc-content").remove();
            }

            if (toc_last === pageAdded) {
              var toc_html;
              toc_html = "";

              $(".page-toc").each(function() {
                toc_html += '<div class="page page-toc">' + $(this).html() + "</div>";
                $(this).remove(); // remove the page-toc div that added in the last after copied
              });
              $(".scrapbook-half-preview-list-wrap .wrapper .homepage-layout").after(toc_html);
              // $('.page.page-toc').last().remove(); // remove the last blank toc page

              $.fn.givePageNumber();
              $.fn.applySlider();
              $.fn.pageNoTotitle();
            }
          }
        }
      });
    }
  };

  $.fn.givePageNumber = function() {
    $(".wrapper .page").each(function(index) {
      $(this).attr("data-pageno", index + 1);
      $(this).attr("id", "page-" + (index + 1));
    });
  };

  $.fn.applySlider = function() {
    var page_number = 0;
    var section = [];
    var section_toc = [];
    var section_data = {};
    var clip_data = {};
    var pagecnt = 0;
    var prev_section_id = 0; // for track last section
    section.push({
      scidx: "cover",
      cid: "cover",
      section_title: $(".cover-page")
        .find(".title")
        .text()
        .trim()
        .substr(0, 30),
      clilp_title: $(".cover-page")
        .find(".author")
        .text()
        .trim()
        .substr(0, 30)
    });

    $(".sections-list")
      .find(".section-idx-0")
      .attr("data-sectionidx", 0);
    section_toc[0] = pagecnt;
    pagecnt++;

    $(".page.page-toc").each(function() {
      var last_toc_page = parseInt(
        $(this)
          .find(".first .page-number-style:first")
          .text()
      );
      if (isNaN(last_toc_page)) {
        // console.log(last_toc_page);
        $(this)
          .parent(".owl-item")
          .remove();
      } else {
        section.push({
          scidx: "toc",
          cid: "toc",
          section_title: $(".toc-title")
            .text()
            .trim()
            .substr(0, 30),
          clilp_title: ""
        });
        pagecnt++;
      }
    });

    $(".page:not(.page-toc):not(.homepage-layout)").each(function() {
      $(this)
        .find(".column")
        .each(function() {
          if ($(this).find(".section-title").length > 0) {
            var sec_id = parseInt(
              $(this)
                .find(".section-title")
                .data("scidx")
            );
            var clip_id = parseInt(
              $(this)
                .find(".title")
                .data("clipid")
            );
            var section_title = $(this)
              .find(".section-title")
              .text()
              .trim()
              .substr(0, 30);

            //if the previous section and the current section have gap more than 1 then set the last section id which have clip data.
            if (sec_id - prev_section_id > 1) {
              $(".sections-list")
                .find(".section-idx-" + (sec_id - 1))
                .attr("data-sectionidx", pagecnt);
            }
            if (!section_toc[sec_id]) {
              if (sec_id != 0) {
                $(".sections-list")
                  .find(".section-idx-" + sec_id)
                  .attr("data-sectionidx", pagecnt + 1);
                section_toc[sec_id] = pagecnt;
              }
              prev_section_id = sec_id; // set the section which have the clip data
            }
          }
        });

      if ($(this).find(".section-title").length > 0) {
        var sec_id = parseInt(
          $(this)
            .find(".section-title")
            .data("scidx")
        );
        var clip_id = parseInt(
          $(this)
            .find(".title")
            .data("clipid")
        );
        var section_title = $(this)
          .find(".section-title")
          .text()
          .trim()
          .substr(0, 30);
        var clip_title = $(this)
          .find(".title")
          .text()
          .trim()
          .substr(0, 30);

        section.push({
          scidx: sec_id,
          cid: clip_id,
          section_title: section_title,
          clilp_title: clip_title
        });
        section_data = {
          scidx: sec_id,
          title: $(this)
            .find(".section-title")
            .text()
            .trim()
            .substr(0, 30)
        };
        clip_data = {
          cid: clip_id,
          title: $(this)
            .find(".title")
            .text()
            .trim()
            .substr(0, 30)
        };
      } else if ($(this).find(".title").length > 0) {
        var clip_id = parseInt(
          $(this)
            .find(".title")
            .data("clipid")
        );
        var clip_title = $(this)
          .find(".title")
          .text()
          .trim()
          .substr(0, 30);
        section.push({
          scidx: section_data["scidx"],
          cid: clip_id,
          section_title: section_data["title"],
          clilp_title: clip_title
        });
        clip_data = {
          cid: clip_id,
          title: clip_title
        };
      } else {
        section.push({
          scidx: section_data["scidx"],
          cid: clip_data["cid"],
          section_title: section_data["title"],
          clilp_title: clip_data["title"]
        });
      }
      pagecnt++;
    });

    // slider
    var total_page = $(".scrapbook-half-preview-list-wrap .wrapper .page").length;

    $(".main-container").after('<div class="slider-content-section"></div>');
    $(".slider-content-section").append(
      '<div class="txt-nav"><input class="current-page" value="1" type="" /> /<span class="total-page">' +
        total_page +
        "</span></div>"
    );
    $(".slider-content-section").append(
      '<div class="nav-scroll"><input id="ex1" data-slider-id="ex1Slider" type="text" data-slider-min="1" data-slider-max="' +
        total_page +
        '" data-slider-step="1" data-slider-value="1"/></div>'
    );
    // console.log(total_page);
    verticalSlider = new mySlider(".nav-scroll #ex1", {
      tooltip: "always",
      orientation: "vertical",
      tooltip_position: "left",
      formatter: function(value) {
        var idx = value - 1;
        if (section[idx].clilp_title == "") {
          return section[idx].section_title;
        } else {
          return (
            "<div class='section-title'>" +
            section[idx].section_title +
            " |</div><div class='title'>  " +
            section[idx].clilp_title +
            "</div>"
          );
        }
      }
    })
      .on("slideStop", function(slideEvt) {
        $(".current-page").val(slideEvt);

        var elmnt = document.getElementById(`page-${slideEvt}`);
        elmnt.scrollIntoView();
      })
      .on("slide", function(slideEvt) {
        $(".tooltip.left").css("margin-left", "-" + $(".tooltip").width() / 2 + "px");
      });

    // page change by textbox
    $("body").on("keydown", ".current-page", function(e) {
      // Allow: backspace, delete, tab, escape, enter and .
      if (
        $.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
        // Allow: Ctrl+A
        (e.keyCode == 65 && e.ctrlKey === true) ||
        // Allow: home, end, left, right, down, up
        (e.keyCode >= 35 && e.keyCode <= 40)
      ) {
        // let it happen, don't do anything

        if (e.keyCode == 13) {
          // owlsliderpage.trigger("to.owl.carousel", [parseInt($(this).val()) - 1, 1, true]);
          var page = $(".current-page").val();
          if ($(`#page-${page}`).offset() != "undefined") {
            $("html, body").animate({
              scrollTop: $(`#page-${page}`).offset().top
            });
          }
        }
        return;
      }
      // Ensure that it is a number and stop the keypress
      if ((e.shiftKey || e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault();
      }
    });
    //table of content
    $(".sections-list .menu__link").click(function() {
      var section_id = parseInt($(this).data("sectionid"));
      if (section_id != null) {
        var elmnt = document.querySelector(`.section-title[id="section-${section_id}"]`);
        elmnt.scrollIntoView();
      }
      $(this).blur();
      return false;
    });
  };

  $.fn.pageNoTotitle = function() {
    var total_toc_pages = parseInt($(".page-toc").length);
    //console.log(total_toc_pages);
    $(".page-toc .page-number").each(function() {
      var no = parseInt($(this).text());
      no = no + total_toc_pages;
      if (!isNaN(no)) {
        $(this).text(no);
      }
      //$(this).parents('.toc-clip-title').find('.page-number-style').text(no);
    });
    $(".page-toc .page-number-style").each(function() {
      var no = parseInt($(this).text());
      no = no + total_toc_pages;
      if (!isNaN(no)) {
        $(this).text(no);
      }
    });

    $(".tooltip.top").css("margin-left", "-" + $(".tooltip").width() / 2 + "px");
  };

  $(document).ready(function() {
    if ($(".node-type-scrapbook").length > 0) {
      $.fn.scrapbookFullPreview.init();
    }
  });

  /**
   * @function
   * @name getWidth
   *
   */
  function getWidth() {
    var myWidth = 0;
    if (typeof window.innerWidth == "number") {
      //Non-IE
      myWidth = window.innerWidth;
    } else if (
      document.documentElement &&
      (document.documentElement.clientWidth || document.documentElement.clientHeight)
    ) {
      //IE 6+ in 'standards compliant mode'
      myWidth = document.documentElement.clientWidth;
    } else if (document.body && (document.body.clientWidth || document.body.clientHeight)) {
      //IE 4 compatible
      myWidth = document.body.clientWidth;
    }
    return myWidth;
  }

  /**
   * @function
   * @name adaptative_columns
   * @see https://github.com/adamwulf/Columnizer-jQuery-Plugin
   */
  function adaptative_columns(screenWidth) {
    content_height = 990;
    number_of_column = 1;
    $(".scrapbook-half-preview-list-wrap").addClass("portrait");
    $("#expand-container .content-container").addClass("portrait");
  }
})(jQuery);

jQuery(document).ready(function($) {
  var msie6 = $.browser == "msie" && $.browser.version < 7;
  if (!msie6 && $(".slider-content-section").length > 0 && $(".slider-content-section").offset() !== null) {
    var height = $(".slider-content-section").height();
    var winHeight = $(window).height();
    var top =
      $(".slider-content-section").offset().top -
      parseFloat(
        $(".slider-content-section")
          .css("margin-top")
          .replace(/auto/, 0)
      );

    var maxY = parseFloat($(".slider-content-section").outerHeight());

    //CalculateSidebar position when page ready(first time)
    calculateSidebarPosition(top, maxY);

    window.addEventListener("scroll", function(event) {
      didScroll = true;
      //Recalculate maxY
      maxY = parseFloat($(".slider-content-section").outerHeight());
      // console.log(`top ${top}, maxY ${maxY}`);

      // what the y position of the scroll is
      calculateSidebarPosition(top, maxY);

      if ($("#slider-vertical").length > 0) {
        var maxSliderValue = $(".tbl-of-contnent li").length - 1;

        var items = $(".clip-list-section li.section-title");
        var lastSectionId = "";
        setTimeout(function() {
          items.each(function(key, value) {
            if ($(value).offset().top - 20 > $(window).scrollTop()) {
            } else {
              lastSectionId = $(value).attr("id");
            }
          });

          if (lastSectionId !== "") {
            var selectedIndex = $("a[href='#" + lastSectionId + "']")
              .parent("li")
              .index();
          }
        }, 200);
      }
    });
  }
});

function calculateSidebarPosition(top, maxY) {
  calculateSliderHeight();
  if ($(window).width() >= 767) {
    var y = $(this).scrollTop();
    $(".slider-content-section")
      .find(".vertical-menu")
      .css({
        "max-height": $(window).height() - 350
      });
    // console.log(`y = ${y}`);
    // console.log(`top = ${top}`);
    if (y > top) {
      $(".slider-content-section")
        .addClass("fixed-slider")
        .removeAttr("style");
    } else {
      $(".slider-content-section").removeClass("fixed-slider");
    }

    var sidebar_height = $(".slider-content-section").height();
    var sidebar_sibling_height = $(".manage-sidebar")
      .next()
      .height();

    if (sidebar_sibling_height < sidebar_height) {
      $(".slider-content-section").css({
        height: sidebar_sibling_height
      });
    } else if (sidebar_height > $(window).height() - 46) {
      $(".slider-content-section").css({
        height: $(window).height() - 46
      });
    } else {
      $(".slider-content-section").css({
        height: sidebar_height
      });
    }
  }
}

$.fn.isInViewport = function() {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();

  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  return elementBottom > viewportTop && elementTop < viewportBottom;
};

function logScroll(e) {
  var scroll_to_page = false;
  $(".page").each(function() {
    var activePage = $(this).data("pageno");
    if ($(this).isInViewport()) {
      $(this).addClass("active");
      if (!scroll_to_page) {
        scroll_to_page = true;
        verticalSlider.setValue(activePage);
        $(".current-page").val(activePage);
      }
    } else {
      $(this).removeClass("active");
    }
  });
}

$(window).on("resize scroll", logScroll);
function calculateSliderHeight() {
  var start_position = $(".scrapbook-half-preview-list-wrap.portrait").offset();
  var slider_height = $(window).height();
  // console.log("slider_height", slider_height);
  if (start_position !== null) {
    slider_height = slider_height - 75 - start_position.top;
  }

  jQuery(".slider.slider-vertical").height(slider_height);
}
